import React, { useState } from 'react';

import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import Container from 'components/shared/Container';
import { FILE_EXPORTS_GENERATE_REPORTS } from 'lib/networking/endpoints';
import { ReportType } from 'lib/enums/ReportGeneratrionEnums';
import Swal from 'sweetalert2';
import SwalDialog from 'lib/utils/toast';
import usePost from 'lib/hooks/usePost';

function GenerateReportsView() {
  const { type } = useParams();
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  const { postData: generateReport } = usePost(
    FILE_EXPORTS_GENERATE_REPORTS,
    () =>
      Swal.fire({
        icon: 'success',
        html: `
        <div>
          The export csv file will be generated in a while. 
          You can download the generated file from\n
          <a
            href="/file-exports"
            rel="noopener noreferrer"
            target="_blank"
          >
            File Exports Page
          </a>
        </div>`,
        title: 'Success',
        position: 'center',
      }),
    () => {
      SwalDialog('error', 'An error occurred while Generationg the File', 'Error', 'center');
    },
  );
  const handleGenerateReport = reportType => {
    const fromDate = new Date(from);
    const toDate = new Date(to);

    if (fromDate > toDate) {
      SwalDialog(
        'error',
        '"From" date cannot be later than the "To" date',
        'Invalid Date Range',
        'center',
      );
      return;
    }
    generateReport({
      from: from,
      to: to,
      report_type: reportType,
    });
  };
  return (
    <Container>
      <div>
        <h3 className="font-weight-bold ml-3">Reporting</h3>
      </div>
      {type === 'activity' && (
        <Row>
          <Col md={4}>
            <Card className="shadow-sm">
              <Card.Body>
                <Card.Title className="mb-3 font-weight-bold">Brand content QA report</Card.Title>
                <Card.Text className="text-muted">
                  A report of brands that are content verified. Report contains brand name,
                  manufacturer name the user who locked the attribute and the date the each
                  attribute got locked.
                </Card.Text>
                <Form>
                  <Form.Group className="mb-3" controlId="reportFromDate">
                    <Form.Label>From</Form.Label>
                    <Form.Control
                      type="date"
                      value={from}
                      onChange={e => setFrom(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="reportToDate">
                    <Form.Label>To</Form.Label>
                    <Form.Control type="date" value={to} onChange={e => setTo(e.target.value)} />
                  </Form.Group>
                  <Button
                    variant="primary"
                    className="w-100"
                    onClick={() => handleGenerateReport(ReportType.BRAND_CONTENT_QA_REPORT_EXPORT)}
                  >
                    Generate report
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="shadow-sm">
              <Card.Body>
                <Card.Title className="mb-3 font-weight-bold">
                  Similar Brand Names QA Report
                </Card.Title>
                <Card.Text className="text-muted">
                  A report of similar brands that were verified in a choosed type.Report will
                  include the vote each user has given.
                </Card.Text>
                <Form>
                  <Form.Group className="mb-3" controlId="reportFromDate">
                    <Form.Label>From</Form.Label>
                    <Form.Control
                      type="date"
                      value={from}
                      onChange={e => setFrom(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="reportToDate">
                    <Form.Label>To</Form.Label>
                    <Form.Control type="date" value={to} onChange={e => setTo(e.target.value)} />
                  </Form.Group>
                  <Button
                    variant="primary"
                    className="w-100"
                    onClick={() =>
                      handleGenerateReport(ReportType.SIMILAR_BRAND_NAMES_QA_REPORT_EXPORT)
                    }
                  >
                    Generate report
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </Container>
  );
}
export default GenerateReportsView;
